import { END_POINTS } from '../helpers';
import { EquipmentData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetEquipmentResponse = {
  count: number;
  data: EquipmentData[];
};

export const equipmentApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getEquipments: builder.query<
      CommonResponse & { data: GetEquipmentResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getEquipment}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteEquipment: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteEquipment}/${id}`,
        method: 'DELETE',
      }),
    }),
    getEquipmentById: builder.query<CommonResponse & { data: EquipmentData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getEquipmentById}/${id}`,
        method: 'GET',
      }),
    }),

    addEquipment: builder.mutation<CommonResponse & { data: EquipmentData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addEquipment}`,
        method: 'POST',
        body,
      }),
    }),
    updateEquipment: builder.mutation<
      CommonResponse & { data: EquipmentData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateEquipment}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddEquipmentMutation,
  useUpdateEquipmentMutation,
  useLazyGetEquipmentsQuery,
  useLazyDeleteEquipmentQuery,
  useLazyGetEquipmentByIdQuery,
} = equipmentApi;
